import React, { useContext, useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import InfoUpdateCard from '../InfoUpdateCard';

const MiniInfoBlock = ({ title, value, type = 'unspecified' }) => {
  return (
    <Box
      id="mini-info-block-container"
      sx={{
        display: 'flex',
        padding: '24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        alignSelf: 'stretch',
        borderRadius: '8px',
        border: '2px solid #EDEDED',
        background: '#FCFCFC',
        maxWidth: '324px',
        minWidth: '324px',
      }}
    >
      <Box
        id="mini-info-block-main-container"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '16px',
          flex: '1 0 0',
          overflow: 'hidden',
        }}
      >
        <Box
          id="yet-another-mini-info-block-container-2"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            alignSelf: 'stretch',
          }}
        >
          <Box
            id="yet-another-mini-info-block-container-3"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '13px',
              alignSelf: 'stretch',
            }}
          >
            <Box
              id="title-container"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '13px',
                alignSelf: 'stretch',
              }}
            >
              <Typography
                sx={{
                  flex: '1 0 0',
                  color: 'var(--color12, #171717)',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                }}
              >
                {title ? title : 'no title provided'}
              </Typography>
            </Box>
            <Typography
              sx={{
                alignSelf: 'stretch',
                color: 'var(--color12, #171717)',
                leadingTrim: 'both',
                textEdge: 'cap',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: 'normal',
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                maxWidth: '250px',
                overflowWrap: 'break-word',
              }}
            >
              {value ? value : 'Loading...'}
            </Typography>
          </Box>
        </Box>
      </Box>
      {type !== 'unspecified' && <InfoUpdateCard editedInfo={type} />}
    </Box>
  );
};

export default MiniInfoBlock;
